import { bindActionCreators } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { login, logout, updateUserProfile } from '../services/user';

export const useActionCreator = () => {
	const dispatch = useDispatch();

	return bindActionCreators({ login, logout, updateUserProfile }, dispatch);
};
